import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @closeModal={{this.closingModal}}
  @title={{this.modalTitle}}
  @flash={{this.flash}}
  @flashType="error"
  id="bookmark-reminder-modal"
  class="bookmark-reminder-modal"
  data-bookmark-id={{this.bookmark.id}}
  {{did-insert this.didInsert}}
>
  <:headerPrimaryAction>
    <DButton
      @label="bookmarks.save"
      @action={{this.saveAndClose}}
      @title="modal.close"
      class="btn-transparent btn-primary"
    />
  </:headerPrimaryAction>

  <:body>
    <div class="control-group bookmark-name-wrap">
      <Input
        id="bookmark-name"
        @value={{this.bookmark.name}}
        name="bookmark-name"
        class="bookmark-name"
        placeholder={{i18n "post.bookmarks.name_placeholder"}}
        aria-label={{i18n "post.bookmarks.name_input_label"}}
      />
      <DButton
        @icon="cog"
        @action={{this.toggleShowOptions}}
        @ariaLabel="post.bookmarks.options"
        @title="post.bookmarks.options"
        class="bookmark-options-button"
      />
    </div>

    {{#if this.showOptions}}
      <div class="bookmark-options-panel">
        <label
          class="control-label"
          for="bookmark_auto_delete_preference"
        >{{i18n "bookmarks.auto_delete_preference.label"}}</label>
        <ComboBox
          @content={{this.autoDeletePreferences}}
          @value={{this.bookmark.autoDeletePreference}}
          @id="bookmark-auto-delete-preference"
          @onChange={{fn (mut this.bookmark.autoDeletePreference)}}
          class="bookmark-option-selector"
        />
      </div>
    {{/if}}

    {{#if this.showExistingReminderAt}}
      <div class="alert alert-info existing-reminder-at-alert">
        {{d-icon "far-clock"}}
        <span>{{i18n
            "bookmarks.reminders.existing_reminder"
            at_date_time=this.existingReminderAtFormatted
          }}</span>
      </div>
    {{/if}}

    <div class="control-group">
      <label class="control-label">
        {{i18n "post.bookmarks.set_reminder"}}
      </label>

      {{#if this.userHasTimezoneSet}}
        <TimeShortcutPicker
          @timeShortcuts={{this.timeOptions}}
          @prefilledDatetime={{this.prefilledDatetime}}
          @onTimeSelected={{this.onTimeSelected}}
          @hiddenOptions={{this.hiddenTimeShortcutOptions}}
          @customLabels={{this.customTimeShortcutLabels}}
          @_itsatrap={{this._itsatrap}}
        />
      {{else}}
        <div class="alert alert-info">{{html-safe
            (i18n "bookmarks.no_timezone" basePath=(base-path))
          }}</div>
      {{/if}}
    </div>
  </:body>

  <:footer>
    <DButton
      @label="bookmarks.save"
      @action={{this.saveAndClose}}
      id="save-bookmark"
      class="btn-primary"
    />
    <DModalCancel @close={{this.closeWithoutSavingBookmark}} />
    {{#if this.showDelete}}
      <DButton
        @icon="trash-alt"
        @action={{this.delete}}
        @ariaLabel="post.bookmarks.actions.delete_bookmark.name"
        @title="post.bookmarks.actions.delete_bookmark.name"
        id="delete-bookmark"
        class="delete-bookmark btn-danger"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "5ZkI+KW7",
  "block": "[[[8,[39,0],[[24,1,\"bookmark-reminder-modal\"],[24,0,\"bookmark-reminder-modal\"],[16,\"data-bookmark-id\",[30,0,[\"bookmark\",\"id\"]]],[4,[38,1],[[30,0,[\"didInsert\"]]],null]],[[\"@closeModal\",\"@title\",\"@flash\",\"@flashType\"],[[30,0,[\"closingModal\"]],[30,0,[\"modalTitle\"]],[30,0,[\"flash\"]],\"error\"]],[[\"headerPrimaryAction\",\"body\",\"footer\"],[[[[1,\"\\n    \"],[8,[39,2],[[24,0,\"btn-transparent btn-primary\"]],[[\"@label\",\"@action\",\"@title\"],[\"bookmarks.save\",[30,0,[\"saveAndClose\"]],\"modal.close\"]],null],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[10,0],[14,0,\"control-group bookmark-name-wrap\"],[12],[1,\"\\n      \"],[8,[39,3],[[24,1,\"bookmark-name\"],[24,3,\"bookmark-name\"],[24,0,\"bookmark-name\"],[16,\"placeholder\",[28,[37,4],[\"post.bookmarks.name_placeholder\"],null]],[16,\"aria-label\",[28,[37,4],[\"post.bookmarks.name_input_label\"],null]]],[[\"@value\"],[[30,0,[\"bookmark\",\"name\"]]]],null],[1,\"\\n      \"],[8,[39,2],[[24,0,\"bookmark-options-button\"]],[[\"@icon\",\"@action\",\"@ariaLabel\",\"@title\"],[\"cog\",[30,0,[\"toggleShowOptions\"]],\"post.bookmarks.options\",\"post.bookmarks.options\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showOptions\"]],[[[1,\"      \"],[10,0],[14,0,\"bookmark-options-panel\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"bookmark_auto_delete_preference\"],[12],[1,[28,[35,4],[\"bookmarks.auto_delete_preference.label\"],null]],[13],[1,\"\\n        \"],[8,[39,6],[[24,0,\"bookmark-option-selector\"]],[[\"@content\",\"@value\",\"@id\",\"@onChange\"],[[30,0,[\"autoDeletePreferences\"]],[30,0,[\"bookmark\",\"autoDeletePreference\"]],\"bookmark-auto-delete-preference\",[28,[37,7],[[28,[37,8],[[30,0,[\"bookmark\",\"autoDeletePreference\"]]],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showExistingReminderAt\"]],[[[1,\"      \"],[10,0],[14,0,\"alert alert-info existing-reminder-at-alert\"],[12],[1,\"\\n        \"],[1,[28,[35,9],[\"far-clock\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"bookmarks.reminders.existing_reminder\"],[[\"at_date_time\"],[[30,0,[\"existingReminderAtFormatted\"]]]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"post.bookmarks.set_reminder\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"userHasTimezoneSet\"]],[[[1,\"        \"],[8,[39,10],null,[[\"@timeShortcuts\",\"@prefilledDatetime\",\"@onTimeSelected\",\"@hiddenOptions\",\"@customLabels\",\"@_itsatrap\"],[[30,0,[\"timeOptions\"]],[30,0,[\"prefilledDatetime\"]],[30,0,[\"onTimeSelected\"]],[30,0,[\"hiddenTimeShortcutOptions\"]],[30,0,[\"customTimeShortcutLabels\"]],[30,0,[\"_itsatrap\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"alert alert-info\"],[12],[1,[28,[35,11],[[28,[37,4],[\"bookmarks.no_timezone\"],[[\"basePath\"],[[28,[37,12],null,null]]]]],null]],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,2],[[24,1,\"save-bookmark\"],[24,0,\"btn-primary\"]],[[\"@label\",\"@action\"],[\"bookmarks.save\",[30,0,[\"saveAndClose\"]]]],null],[1,\"\\n    \"],[8,[39,13],null,[[\"@close\"],[[30,0,[\"closeWithoutSavingBookmark\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"showDelete\"]],[[[1,\"      \"],[8,[39,2],[[24,1,\"delete-bookmark\"],[24,0,\"delete-bookmark btn-danger\"]],[[\"@icon\",\"@action\",\"@ariaLabel\",\"@title\"],[\"trash-alt\",[30,0,[\"delete\"]],\"post.bookmarks.actions.delete_bookmark.name\",\"post.bookmarks.actions.delete_bookmark.name\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[],false,[\"d-modal\",\"did-insert\",\"d-button\",\"input\",\"i18n\",\"if\",\"combo-box\",\"fn\",\"mut\",\"d-icon\",\"time-shortcut-picker\",\"html-safe\",\"base-path\",\"d-modal-cancel\"]]",
  "moduleName": "discourse/components/modal/bookmark.hbs",
  "isStrictMode": false
});